'use strict';

/*global services*/
/*global pjcpPrepared*/
/*global pjcpSemiPrepared*/

/*exported clearQueueFilter */
function clearQueueFilter() {
  $('#production-queue-form').find('.clear-filter').trigger('click');
}

/*exported reloadQueuePage */
function reloadQueuePage($countdown) {
  if (!$('.modal:visible').length) {
    $countdown.addClass('countdown-pause');

    if (services.get('configurations').param('resource_id')) {
      location.href = services.get('router').path('production_queue', { WorkplaceRID: services.get('configurations').param('workplace_rid') });
    } else {
      location.reload();
    }
  }
}

/*exported updateButtonByPreparationStatus*/
function updateButtonByPreparationStatus($btn, preparationStatus) {
  $btn.removeClass('btn-success');
  $btn.removeClass('btn-warning');
  $btn.removeClass('btn-danger');

  if (preparationStatus === pjcpPrepared) {
    $btn.addClass('btn-success');
  } else if (preparationStatus === pjcpSemiPrepared) {
    $btn.addClass('btn-warning');
  } else {
    $btn.addClass('btn-danger');
  }

  $btn.data('preparation_status', preparationStatus);
}
